/**
 * RGBA pixels → an ESC/POS raster print: init, `GS v 0` image, feed, cut.
 *
 * The encoding half of the multi-language (HTML) receipt. Drawing the HTML into pixels needs a
 * browser, so that step is the host's `Rasterizer`; this half is pure arithmetic and is shared by
 * every host that has one.
 *
 * Ported byte for byte from `apps/web/src/helper/printHelper.js` `pixelDataToEscPosContent`.
 * The threshold (luma < 150 prints) was tuned on real receipts there — it is a calibration value,
 * not a derivation, so change it only against paper.
 */
const DARK_BELOW = 150;

export function encodeRaster(rgba: ArrayLike<number>, width: number, height: number, mode = 0): Uint8Array {
  const bytes: number[] = [0x1b, 0x40]; // ESC @ — initialise

  const widthBytes = Math.ceil(width / 8);
  bytes.push(0x1d, 0x76, 0x30, mode, widthBytes & 0xff, (widthBytes >> 8) & 0xff, height & 0xff, (height >> 8) & 0xff);

  for (let y = 0; y < height; y++) {
    for (let xByte = 0; xByte < widthBytes; xByte++) {
      let byte = 0;
      for (let bit = 0; bit < 8; bit++) {
        const x = xByte * 8 + bit;
        if (x >= width) continue;
        const i = (y * width + x) * 4;
        const luma = 0.3 * rgba[i] + 0.59 * rgba[i + 1] + 0.11 * rgba[i + 2];
        if (luma < DARK_BELOW) byte |= 0x80 >> bit;
      }
      bytes.push(byte);
    }
  }

  bytes.push(0x1b, 0x64, 0x02); // ESC d 2 — feed, or the last lines stay under the cutter
  bytes.push(0x1d, 0x56, 0x41, 0x10); // GS V A — cut
  return Uint8Array.from(bytes);
}
